import { render, staticRenderFns } from "./FollowupPersonnel.vue?vue&type=template&id=3767f9f6"
import script from "./FollowupPersonnel.vue?vue&type=script&lang=js"
export * from "./FollowupPersonnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports